import React from 'react';
import PropTypes from 'prop-types';
import t from 'format-message';
import { Flex } from '@instructure/ui-flex';
import { Table } from '@instructure/ui-table';
import { Text } from '@instructure/ui-text';
import { View } from '@instructure/ui-view';
import { ScreenReaderContent, PresentationContent } from '@instructure/ui-a11y-content';
import { scoringTierShape } from "../../store/shapes.js";
var Ratings = function Ratings(_ref) {
  var ratings = _ref.ratings,
    masteryPercent = _ref.masteryPercent,
    pointsPossible = _ref.pointsPossible,
    isTray = _ref.isTray;
  // This will ensure that the points is calculated to at most 2 decimal points
  var percentToPoints = function percentToPoints(percent) {
    return Math.round(percent * pointsPossible * 100) / 100;
  };
  var renderRatingDescription = function renderRatingDescription(description, position) {
    return /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Description for mastery level {position}: {description}', {
      position: position,
      description: description
    })), /*#__PURE__*/React.createElement(PresentationContent, null, description));
  };
  var renderRatingsPoints = function renderRatingsPoints(points, position) {
    return /*#__PURE__*/React.createElement(View, {
      display: isTray ? 'inline-block' : 'auto'
    }, /*#__PURE__*/React.createElement(View, {
      margin: isTray ? '0' : '0 0 0 small'
    }, /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Points for mastery level {position}: {points}', {
      position: position,
      points: points
    })), /*#__PURE__*/React.createElement(PresentationContent, null, isTray ? t('{points} points', {
      points: points
    }) : points, !isTray && /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'none'
      }
    }, t('points')))));
  };
  var renderDisplayMasteryPoints = function renderDisplayMasteryPoints() {
    var masteryPoints = percentToPoints(masteryPercent);
    return /*#__PURE__*/React.createElement(Flex, {
      wrap: "wrap",
      direction: isTray ? 'column' : 'row',
      padding: isTray ? 'none small small none' : 'x-small small small none'
    }, /*#__PURE__*/React.createElement(Flex.Item, {
      as: "div",
      padding: "none xx-small none none"
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "bold"
    }, t('Mastery at:'))), /*#__PURE__*/React.createElement(Flex.Item, {
      padding: isTray ? 'small none none' : 'none'
    }, /*#__PURE__*/React.createElement(Text, {
      color: "primary"
    }, t('{masteryPoints} points', {
      masteryPoints: masteryPoints
    }))));
  };
  return /*#__PURE__*/React.createElement(Flex, {
    width: "100%",
    direction: "column"
  }, /*#__PURE__*/React.createElement(Flex, {
    width: isTray ? '100%' : '65%',
    padding: "x-small 0"
  }, /*#__PURE__*/React.createElement(Table, {
    caption: t('Ratings table'),
    layout: "fixed"
  }, /*#__PURE__*/React.createElement(Table.Head, null, /*#__PURE__*/React.createElement(Table.Row, {
    themeOverride: {
      borderColor: 'white'
    }
  }, /*#__PURE__*/React.createElement(Table.ColHeader, {
    id: "rating",
    themeOverride: {
      padding: '0.5rem 0rem'
    }
  }, t('Proficiency Rating')), !isTray && /*#__PURE__*/React.createElement(Table.ColHeader, {
    id: "points",
    textAlign: "end",
    themeOverride: {
      padding: '0.5rem 0rem'
    }
  }, t('Points')))), ratings === null || ratings === void 0 ? void 0 : ratings.map(function (_ref2, index) {
    var description = _ref2.description,
      percent = _ref2.percent;
    return /*#__PURE__*/React.createElement(Table.Body, {
      key: index
    }, /*#__PURE__*/React.createElement(Table.Row, {
      themeOverride: {
        borderColor: 'white'
      }
    }, /*#__PURE__*/React.createElement(Table.Cell, {
      themeOverride: {
        padding: '0.5rem 0rem'
      }
    }, renderRatingDescription(description, index + 1)), !isTray && /*#__PURE__*/React.createElement(Table.Cell, {
      textAlign: "end",
      themeOverride: {
        padding: '0rem 2.25rem'
      }
    }, renderRatingsPoints(percentToPoints(percent), index + 1))), isTray && /*#__PURE__*/React.createElement(Table.Row, {
      themeOverride: {
        borderColor: 'white',
        padding: '0rem 0rem'
      }
    }, /*#__PURE__*/React.createElement(Table.Cell, {
      themeOverride: {
        padding: '0.5rem 0rem'
      }
    }, renderRatingsPoints(percentToPoints(percent), index + 1))));
  }))), renderDisplayMasteryPoints());
};
Ratings.propTypes = {
  ratings: PropTypes.arrayOf(scoringTierShape),
  masteryPercent: PropTypes.number,
  pointsPossible: PropTypes.number,
  isTray: PropTypes.bool
};
Ratings.defaultProps = {
  ratings: [],
  masteryPercent: null,
  pointsPossible: null,
  isTray: false
};
export default Ratings;